/**
 * Phase 16.5.1 — Admin-Auth-Helpers (Frontend).
 *
 * Passwort wird in `sessionStorage` gehalten — beim Tab-Schließen weg, weniger
 * Risiko bei XSS als localStorage. Der Header-Wert ist `Admin <password>`.
 */
const SESSION_KEY = 'dispatch24_admin_pw';

export function getAdminPassword(): string | null {
  try {
    return window.sessionStorage.getItem(SESSION_KEY);
  } catch {
    return null;
  }
}

export function setAdminPassword(pw: string): void {
  try {
    window.sessionStorage.setItem(SESSION_KEY, pw);
  } catch {
    // ignore
  }
}

export function clearAdminPassword(): void {
  try {
    window.sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // ignore
  }
}

export function adminAuthHeaders(): HeadersInit {
  const pw = getAdminPassword() ?? '';
  return { Authorization: `Admin ${pw}` };
}
